const _excluded = ["nodes"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from 'prop-types';
import React from 'react';
import ControlFilterSwitch from '../common/controls/controlFilterSwitch';
import entityComposition from '../common/classes/entityComposition';
import pagerFactory from '../common/pagingTable/pagerFactory';
import searchFactory from '../common/lookups/searchFactory';
import tieredFilterEntity from '../common/lookups/tieredFilterEntity';
import { getReportNumber } from '../reports/reportSelectors';
// import IssueItemFilterSearch from './issueItemFilterSearch';
import IssueItemFilter from './issueItemFilter';
import displaySettingUtil from '../../utils/displaySettings';
const JobComponentCodeFilter = tieredFilterEntity('issue', 'jobComponentCodeFilterIssue', 'jobComponentCode');
const JobComponentCodeSearch = searchFactory('jobComponentCodeFilterIssue');
const IssueCreatorFilter = tieredFilterEntity('issue', 'creatorFilterIssue', 'user');
const IssueCreatorSearch = searchFactory('creatorFilterIssue');
const IssueJobFilter = tieredFilterEntity('issue', 'jobFilterIssue', 'job');
const IssueJobSearch = searchFactory('jobFilterIssue');
const IssueReportFilter = tieredFilterEntity('issue', 'reportFilterIssue', 'report');
const IssueReportSearch = searchFactory('reportFilterIssue');
const IssueIssueItemSearch = searchFactory('issueIssueItem');
const IssueReportTypeFilter = tieredFilterEntity('issue', 'reportTypeFilterIssue', 'reportType');
const IssueReportTypeSearch = searchFactory('reportTypeFilterIssue');
const IssueSeverityFilter = tieredFilterEntity('issue', 'issueSeverityFilterIssue', 'issueSeverity');
const IssueSeveritySearch = searchFactory('issueSeverityFilterIssue');
const IssueStatusFilter = tieredFilterEntity('issue', 'issueStatusFilterIssue', 'issueStatus');
const IssueStatusSearch = searchFactory('issueStatusFilterIssue');
const JobIssuePager = pagerFactory('jobFilterIssue');
const ReportPager = pagerFactory('reportFilterIssue');
const IssueAssignmentFilter = tieredFilterEntity('issue', 'issueAssignmentFilterIssue', 'issueAssignment');
const IssueAssignmentSearch = searchFactory('issueAssignmentFilterIssue');
const getReportOptionName = incomingOption => {
  const option = JSON.parse(JSON.stringify(incomingOption));
  option.name = getReportNumber(option);
  return option;
};
const getJobOptionName = option => _objectSpread(_objectSpread({}, option), {}, {
  name: option.jobNumber
});
const IssuesFilters = props => {
  const {
    issue: {
      indexQuery: {
        filters
      },
      indexQuery
    },
    displaySettings,
    issueActions: {
      serverFilter
    }
  } = props;
  // must be declared here so the ref callback can refer to it
  let controlFilterSwitch = null;
  const handleBack = () => {
    // switch control back to top level.
    controlFilterSwitch.controlSwitch.switchControl();
  };
  const handleIssueItemChange = values => {
    const parsedValues = values.map(_ref => {
      let {
          nodes
        } = _ref,
        all = _objectWithoutProperties(_ref, _excluded);
      return all;
    });

    // the issue items and others are combines in this values array.
    let {
      issueItem = [],
      issueItemOther = []
    } = filters;

    // remove any not in the values selected in case user de-selected them
    issueItem = issueItem.filter(item => parsedValues.some(selection => item.id === selection.id));
    issueItemOther = issueItemOther.filter(item => parsedValues.some(selection => item.id === selection.id));

    // this array only has IDs for existing/prior selections.  it has
    // `name` property for new selections,
    // which allows us to categorize it as Other or not.  remove any values already
    // in the filters.
    const newValues = parsedValues.filter(val => issueItem.every(filterItem => filterItem.id !== val.id) && issueItemOther.every(filterItem => filterItem.id !== val.id)).filter(val => val.name !== undefined);
    newValues.forEach(val => {
      if (val.name.includes('Other: ')) {
        issueItemOther.push(val);
      } else {
        issueItem.push(val);
      }
    });
    const newFilters = _objectSpread(_objectSpread({}, filters), {}, {
      issueItem,
      issueItemOther
    });
    serverFilter(newFilters, indexQuery);
  };

  // get default selections for issueItemFilter from props.issue.filters
  let itemSelections = [];
  if (filters && filters.issueItem) {
    itemSelections = filters.issueItem;
  }
  if (filters && filters.issueItem) {
    itemSelections = itemSelections.concat(filters.issueItemOther.map(item => _objectSpread(_objectSpread({}, item), {}, {
      // set sort order to high number on others so they go to bottom of the list.
      sortOrder: 9999
    })));
  }
  const issueItemFilter = /*#__PURE__*/React.createElement(IssueItemFilter, {
    onChange: handleIssueItemChange,
    label: "Items",
    selection: itemSelections,
    filters: filters,
    onBack: handleBack
  }, /*#__PURE__*/React.createElement(IssueIssueItemSearch, null));
  const issueJobFilter = /*#__PURE__*/React.createElement(IssueJobFilter, {
    label: "Job",
    getOptionName: getJobOptionName,
    onBack: handleBack,
    searchLocally: false
  }, /*#__PURE__*/React.createElement(IssueJobSearch, null), /*#__PURE__*/React.createElement(JobIssuePager, null));
  const issueReportTypeFilter = /*#__PURE__*/React.createElement(IssueReportTypeFilter, {
    label: "Report Type",
    onBack: handleBack
  }, /*#__PURE__*/React.createElement(IssueReportTypeSearch, null));

  // reportsWithIssues triggers the archive report filter in findAll
  const issueReportFilter = /*#__PURE__*/React.createElement(IssueReportFilter, {
    label: "Report",
    getOptionName: getReportOptionName,
    onBack: handleBack,
    searchLocally: false
  }, /*#__PURE__*/React.createElement(IssueReportSearch, {
    placeholder: "search in current page"
  }), /*#__PURE__*/React.createElement(ReportPager, null));
  // filterOnCreator: is there to trigger the filter handling on the server
  const issueCreatorFilter = /*#__PURE__*/React.createElement(IssueCreatorFilter, {
    label: "Creator",
    onBack: handleBack
  }, /*#__PURE__*/React.createElement(IssueCreatorSearch, null));
  const issueStatusSelect = /*#__PURE__*/React.createElement(IssueStatusFilter, {
    label: "Issue Status",
    onBack: handleBack
  }, /*#__PURE__*/React.createElement(IssueStatusSearch, null));
  const issueSeveritySelect = /*#__PURE__*/React.createElement(IssueSeverityFilter, {
    label: "Issue Severity",
    onBack: handleBack
  }, /*#__PURE__*/React.createElement(IssueSeveritySearch, null));
  const jobComponentCodeSelect = /*#__PURE__*/React.createElement(JobComponentCodeFilter, {
    label: "Components",
    onBack: handleBack
  }, /*#__PURE__*/React.createElement(JobComponentCodeSearch, null));
  const issueAssignmentFilter = /*#__PURE__*/React.createElement(IssueAssignmentFilter, {
    label: "Assigned To",
    getOptionName: option => _objectSpread(_objectSpread({}, option), {}, {
      name: `${option.firstName} ${option.lastName}`
    }),
    onBack: handleBack
  }, /*#__PURE__*/React.createElement(IssueAssignmentSearch, null));
  const filterControls = [{
    filterName: ['issueItem', 'issueItemOther'],
    label: 'Items',
    entity: 'issueItem',
    control: issueItemFilter,
    filters
  }, {
    label: 'Job',
    entity: 'job',
    filterName: 'job',
    control: issueJobFilter,
    filters
  }, {
    label: 'Assigned To',
    entity: 'IssueAssignment',
    filterName: 'issueAssignment',
    control: issueAssignmentFilter,
    filters
  }, {
    label: 'Report Types',
    filterName: 'reportType',
    entity: 'reportType',
    control: issueReportTypeFilter,
    filters
  }, {
    label: 'Report',
    entity: 'report',
    filterName: 'report',
    control: issueReportFilter,
    filters
  }, {
    label: 'Creator',
    filterName: 'user',
    entity: 'user',
    control: issueCreatorFilter,
    filters
  }, {
    label: 'Issue Status',
    entity: 'issueStatus',
    filterName: 'issueStatus',
    control: issueStatusSelect,
    filters
  }, {
    label: 'Issue Severity',
    entity: 'issueSeverity',
    filterName: 'issueSeverity',
    control: issueSeveritySelect,
    filters
  }];
  if (displaySettingUtil.shouldDisplay(['issue_components'], displaySettings.list)) {
    filterControls.push({
      label: 'Component',
      entity: 'jobComponentCode',
      filterName: 'jobComponentCode',
      control: jobComponentCodeSelect,
      filters
    });
  }
  return /*#__PURE__*/React.createElement(ControlFilterSwitch, {
    filterControls: filterControls,
    ref: input => {
      controlFilterSwitch = input;
    }
  });
};
IssuesFilters.propTypes = {
  displaySettings: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  issue: PropTypes.shape({
    indexQuery: PropTypes.shape({
      filters: PropTypes.shape({
        issueItem: PropTypes.arrayOf(PropTypes.shape({})),
        issueItemOther: PropTypes.arrayOf(PropTypes.shape({}))
      })
    }).isRequired
  }).isRequired,
  issueActions: PropTypes.shape({
    addFilter: PropTypes.func,
    serverFilter: PropTypes.func
  }).isRequired
};
export { IssuesFilters as TestIssuesFilters };
export default entityComposition(IssuesFilters, ['issue', 'displaySettings'], {}, []);